module.exports = __webpack_public_path__ + "static/3-4adbd9b41756906cc0f5d0978d74cfe5.jpg";